module.exports = __webpack_public_path__ + "static/media/to-everspace.4b95c95d.jpg";